function Directive(moduleOrName: string | ng.IModule, selector: string, options: ng.IDirective) {
    return (controller: Function) => {
        var module = typeof moduleOrName === "string" ? angular.module(moduleOrName) : moduleOrName;
        module.directive(selector, () => angular.extend(options, { controller: controller }));
    }
}